import { render, staticRenderFns } from "./SendOrder.vue?vue&type=template&id=5ee64300&scoped=true"
import script from "./SendOrder.vue?vue&type=script&lang=js"
export * from "./SendOrder.vue?vue&type=script&lang=js"
import style0 from "./SendOrder.vue?vue&type=style&index=0&id=5ee64300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee64300",
  null
  
)

export default component.exports